import HeaderImageBar from './headerImageBar'

export default HeaderImageBar